/**
 * Site-wide configuration — loaded at runtime from AWS SSM.
 *
 * The ECS container entrypoint reads SSM parameters and writes them to
 * /config.js as window.__CONFIG__ before nginx starts. This file is
 * loaded via <script src="/config.js"> in index.html BEFORE the React
 * bundle, so the values are available synchronously.
 *
 * NEVER hardcode moremail.com or any domain in source files.
 */

interface SiteConfig {
  API_URL: string;
  SITE_URL: string;
  DOCS_URL: string;
  CONTACT_EMAIL: string;
  TRACKING_CNAME: string;
  DEEPSEEK_API_KEY: string;
  DEEPSEEK_MODEL: string;
}

declare global {
  interface Window {
    __CONFIG__?: Partial<SiteConfig>;
  }
}

const cfg = window.__CONFIG__ || {};

/** API base URL. e.g. "https://api.moremail.com/api" */
export const API_URL = cfg.API_URL || "/api";

/** Primary site URL, no trailing slash. e.g. "https://moremail.com" */
export const SITE_URL = cfg.SITE_URL || "";

/** Docs site URL. e.g. "https://docs.moremail.com" */
export const DOCS_URL = cfg.DOCS_URL || "";

/** Contact email shown on public pages */
export const CONTACT_EMAIL = cfg.CONTACT_EMAIL || "";

/** CNAME target for custom tracking domains */
export const TRACKING_CNAME_TARGET = cfg.TRACKING_CNAME || "";

/** DeepSeek API key for public AI tools */
export const DEEPSEEK_API_KEY = cfg.DEEPSEEK_API_KEY || "";

/** DeepSeek model name */
export const DEEPSEEK_MODEL = cfg.DEEPSEEK_MODEL || "deepseek-chat";
